export default {
    ReadAsMaster(action, self, ReadMasterSuccess, ReadMasterFailed) {
        return {
            data : {          
              AuthorizationToken : self.props.UserReducer.token,
            },
            self : self,
            action : action,
            onsuccess : ReadMasterSuccess,
            onfailed : ReadMasterFailed,
       }
    },
    ReadMasterReservation(action, self, ReadMasterSuccess, ReadMasterFailed, alias) {
        return {
            data : {   
                query: alias,
                AuthorizationToken : self.state.UserReducer.token,
            },
            self : self,
            action : action,
            onsuccess : ReadMasterSuccess,
            onfailed : ReadMasterFailed,
       }
    },
    ReadProps(action, self, OnReadSuccess, OnReadFailed, filter, order, page) {
        return {
            data : {
              filter: filter,
              order: order,
              AuthorizationToken : self.props.UserReducer.token,
              page : page
            },
            self : self,
            action : action,
            onsuccess : self.OnReadSuccess,
            onfailed : self.OnReadFailed,
       }
    },
    ReadMaintenanceByAssetProp(action, self, OnReadMaintenanceSuccess, OnReadMaintenanceFailed){
        return {
            data: {
                query: self.props.SelectedItem.Alias,
                isInternalAsset : self.props.SelectedItem.IsInternalAsset,
                AuthorizationToken: self.props.UserReducer.token,
            },
            self : self,
            action : action,
            onsuccess : self.OnReadMaintenanceSuccess,
            onfailed : self.OnReadMaintenanceFailed,
        }
    },
    ReadTrackingProps(action, self, OnReadTrackingSuccess, OnReadTrackingFailed){
        return {
            data: {
                query: self.props.SelectedItem.Alias,
                AuthorizationToken: self.props.UserReducer.token,
            },
            self : self,
            action : action,
            onsuccess : self.OnReadTrackingSuccess,
            onfailed : self.OnReadTrackingFailed,
        }
    },
    ReadCommentsProps(action, self, onReadSuccess, onReadFailed) {
      return {
        data: {
         query              :  self.state.SelectedNote.Alias,
         AuthorizationToken : self.props.UserReducer.token,
        },
        action : action,
        self: self,
        onsuccess: onReadSuccess,
        onfailed : onReadFailed,
      }
    },
    RegisterCommentProps(onRegisterSuccess, onRegisterFailed, self){
      return {
        data : {
          // Parent  : self.state.Register.Alias,
          Parent  : self.state.SelectedNote.Alias,
          Content : self.state.Register.Comment,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self: self,
        onsuccess: onRegisterSuccess,
        onfailed : onRegisterFailed,
      }
    },

    RegisterBookingProps(self, onRegisterSuccess, onRegisterFailed) {
      console.log("----------")
      console.log(self)
      console.log("----------")
        return {
            data : {
                Asset              : self.state.SelectedItem.Alias,
                StartDate          : self.RequestParams.StartDate,
                FinishDate         : self.RequestParams.EndDate,
                Site               : self.state.Site,
                Location           : self.state.Location,
                Description        : self.state.Description,
                AuthorizationToken : self.props.UserReducer.token,
            },
            self: self,
            onsuccess: onRegisterSuccess,
            onfailed : onRegisterFailed,
        }
    },

    RegisterNoteProps(self, onRegisterSuccess, onRegisterFailed) {
        return {
            data : {
                Asset       : self.props.SelectedAsset.Alias,
                Name        : self.state.title,
                Description : self.state.description,
                AuthorizationToken : self.props.UserReducer.token,
            },
            self: self,
            onsuccess: onRegisterSuccess,
            onfailed : onRegisterFailed,
        }

    },

    RegisterRequestMaintenance(self, onsuccess, onfailed) {
      return {
        data : {
          field: {
            Asset       : self.state.Asset,
            Service     : self.state.Service,
            Description : self.state.Description,
          },
          AuthorizationToken : self.props.UserReducer.token,
        },
        self: self,
        onsuccess: self.onRequestSuccess,
        onfailed : self.onRequestFailed,
      }
    }
}


// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/request.props.js